import { useQuery } from "@apollo/client";
import { Alert, SxProps, Theme } from "@mui/material";
import { ReactElement } from "react";

import { GetCampaignPersonalizedGifPreviewQuery } from "~frontend/__generated__/graphql";
import { GET_CAMPAIGN_PERSONALIZED_GIF_PREVIEW } from "~frontend/graphql/scripts";

import { GifWithLoadingState } from "./GifWithLoadingState";

export function CampaignPersonalizedGifPreview({
  campaignPersonalizedGifId,
  personalizedGifId,
  campaignId,
  sampleContactData = {},
  pauseOnMouseOff,
  sx,
}: {
  campaignPersonalizedGifId?: string | null;
  personalizedGifId?: string | null;
  campaignId: string;
  sampleContactData?: Record<string, string>;
  pauseOnMouseOff?: boolean;
  sx?: SxProps<Theme>;
}): ReactElement {
  const { error, data, loading } =
    useQuery<GetCampaignPersonalizedGifPreviewQuery>(
      GET_CAMPAIGN_PERSONALIZED_GIF_PREVIEW,
      {
        variables: {
          input: {
            campaignPersonalizedGifId,
            personalizedGifId,
            campaignId,
            contactData: JSON.stringify(sampleContactData),
          },
        },
      }
    );

  if (error) {
    return <Alert severity="error">Failed to load gif preview</Alert>;
  }

  return (
    <GifWithLoadingState
      loading={loading}
      gifUrl={data?.getCampaignPersonalizedGifPreviewLink.gifUrl ?? ""}
      pngUrl={data?.getCampaignPersonalizedGifPreviewLink.pngUrl ?? ""}
      pauseOnMouseOff={pauseOnMouseOff}
      sx={sx}
    />
  );
}
